// @flow
import React from 'react';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  errorStatusCode: {
    paddingTop: `${theme.spacing(1)}px`,
  },
});

type Props = {
  error: any,
  classes: Object,
}

const ContentView = (props: Props) => {
  const { classes, error } = props;

  const helpTextIsString = typeof helpText === 'string';

  return (
    <>
      {error.helpText && helpTextIsString &&
        <Typography variant="body2">
          {error.helpText}
        </Typography>
      }
      {error.helpText && !helpTextIsString &&
        error.helpText
      }
      {error.statusCode &&
        <Typography className={classes.errorStatusCode} variant="caption">
          Care Code: {error.statusCode}
        </Typography>
      }
    </>
  );
};

export default withStyles(styles)(ContentView);
